import React,  { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

export default function LoadingModal({showModal, modalTxt, modalAdditionalTxt}) {

    return (
        <Modal
            show={showModal}
            backdrop="static"
            keyboard={false}
            size={'sm'}
            centered={true}
            contentClassName={'bg-secondary p-3'}
            className={'justify-content-center'}>
            <div className={'text-center text-white'}>
                <i className={'fas fa-spinner fa-spin font-26'}></i>
                <h4 className={'mt-3 text-primary font-family-secondary'}>{modalTxt}</h4>
                <p>{modalAdditionalTxt}</p>
            </div>
        </Modal>
    )
}